import { render } from "./Cameras.vue?vue&type=template&id=70c197f8&scoped=true"
import script from "./Cameras.vue?vue&type=script&lang=js"
export * from "./Cameras.vue?vue&type=script&lang=js"

import "./Cameras.vue?vue&type=style&index=0&id=70c197f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c197f8"]])

export default __exports__